import { render, staticRenderFns } from "./IndicatorTabs.vue?vue&type=template&id=1686052c&scoped=true&"
import script from "./IndicatorTabs.vue?vue&type=script&lang=js&"
export * from "./IndicatorTabs.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorTabs.vue?vue&type=style&index=0&id=1686052c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1686052c",
  null
  
)

export default component.exports